import React, { useState } from 'react';

const DecryptModal = ({ isOpen, onClose, onDecrypt, resolutionId }) => {
	const [decryptKey, setDecryptKey] = useState('');
	const [isDecrypting, setIsDecrypting] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!decryptKey.trim()) return;

		setIsDecrypting(true);
		try {
			await onDecrypt(resolutionId, decryptKey);
			handleClose();
		} catch (error) {
			// Error handling is done in parent component
		} finally {
			setIsDecrypting(false);
		}
	};

	const handleClose = () => {
		setDecryptKey('');
		setIsDecrypting(false);
		onClose();
	};

	if (!isOpen) return null;

	return (
		<div className='fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50'>
			<div className='bg-white rounded-lg shadow-lg w-full max-w-md mx-4'>
				<div className='p-6'>
					<h2 className='text-xl font-bold mb-4 flex items-center'>
						<span className='mr-2'>🔓</span>
						Enter Decryption Key
					</h2>

					<p className='text-sm text-gray-600 mb-4'>
						This resolution is encrypted. Please enter your decryption key to view its content.
					</p>

					<form onSubmit={handleSubmit}>
						<div className='mb-4'>
							<label className='block text-sm font-medium text-gray-700 mb-1'>Decryption Key</label>
							<input
								type='password'
								value={decryptKey}
								onChange={(e) => setDecryptKey(e.target.value)}
								className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
								placeholder='Enter your decryption key'
								required
								disabled={isDecrypting}
								autoFocus
							/>
						</div>
					</form>
				</div>

				<div className='bg-gray-50 px-6 py-3 rounded-b-lg flex justify-end space-x-3'>
					<button
						type='button'
						onClick={handleClose}
						disabled={isDecrypting}
						className='px-4 py-2 bg-gray-300 text-gray-700 rounded-md text-sm hover:bg-gray-400 disabled:opacity-50'
					>
						Cancel
					</button>
					<button
						onClick={handleSubmit}
						disabled={isDecrypting || !decryptKey.trim()}
						className='px-4 py-2 bg-blue-500 text-white rounded-md text-sm hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed'
					>
						{isDecrypting ? (
							<>
								<span className='inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2'></span>
								Decrypting...
							</>
						) : (
							'Decrypt'
						)}
					</button>
				</div>
			</div>
		</div>
	);
};

export default DecryptModal;
